export default "__VITE_ASSET__BuJkBZSe__"